import { render } from "./ourHeshPage.vue?vue&type=template&id=def213da"
import script from "./ourHeshPage.vue?vue&type=script&lang=js"
export * from "./ourHeshPage.vue?vue&type=script&lang=js"

import "./ourHeshPage.vue?vue&type=style&index=0&id=def213da&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__